module.exports = __webpack_public_path__ + "static/media/038.7cd27ed8.png";